import React, { useContext } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useHistory } from "react-router-dom";
import { useMediaQuery, useTheme } from "@material-ui/core";
import {
  HvVerticalNavigation,
  HvVerticalNavigationTree,
  HvVerticalNavigationActions,
  HvVerticalNavigationAction,
} from "@hitachivantara/uikit-react-core";
import { ThemeSwitcher, LogOut } from "@hitachivantara/uikit-react-icons";
import { ThemeContext } from "lib/context/ThemeContext";
import { NavigationContext } from "lib/context/NavigationContext";
import useStyles from "./styles";

const VerticalNavigation: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const { toggleTheme } = useContext(ThemeContext);
  const { navigation, activePath } = useContext(NavigationContext);

  const handleChange = (
    event: React.SyntheticEvent,
    selection: NavigationData
  ) => {
    if (selection.path) history.push(selection.path);
  };

  return (
    <div className={classes.root}>
      <HvVerticalNavigation>
        {navigation != null && (
          <HvVerticalNavigationTree
            data={navigation}
            selected={activePath?.id != null ? activePath.id : ""}
            onChange={handleChange}
          />
        )}

        {!isMdUp && (
          <HvVerticalNavigationActions>
            <HvVerticalNavigationAction
              label="Toggle Theme"
              icon={<ThemeSwitcher />}
              onClick={() => toggleTheme()}
            />
            <HvVerticalNavigationAction
              label="Logout"
              icon={keycloak?.authenticated && <LogOut />}
              onClick={() => keycloak?.logout()}
            />
          </HvVerticalNavigationActions>
        )}
      </HvVerticalNavigation>
    </div>
  );
};

export default VerticalNavigation;
